import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userLoginToken: null, // Token for authentication
  userProfileData: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserToken: (state, action) => {
      state.userLoginToken = action.payload;
    },
    setUserProfileData: (state, action) => {
      state.userProfileData = action.payload;
    },
    clearUser: (state) => {
      state.userLoginToken = null;
      state.userProfileData = null;
    },
  },
});

export const { setUserToken, clearUser, setUserProfileData } =
  userSlice.actions;
export default userSlice.reducer;
